<template>
  <b-form @submit.prevent="login">
    <div class="app flex-row align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-5">
            <Alert type="warning" v-bind:content="errorText" v-bind:show="errorShow" v-on:close-alert="closeAlert"/>
            <div class="card-group mb-0">
              <div class="card">
                <div class="card-body">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-user"></i></span>
                    <input type="text" class="form-control" placeholder="Username" v-model="username" id="username">
                  </div>
                  <div class="input-group mb-4">
                    <span class="input-group-addon"><i class="icon-lock"></i></span>
                    <input type="password" class="form-control" placeholder="Password" v-model="password" id="password">
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <button type="submit" class="btn btn-primary px-4" id="loginButton" :disabled="disabled">
                        <span v-if="beforeClick"> Login</span>
                        <span v-else> Loading..</span>
                        <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
                      </button>
                    </div>
                    <div style="display: none;" class="col-6 text-right">
                      <button type="button" class="btn btn-link px-0">Forgot password?</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
/* eslint-disable */
// import {USER_LOGIN} from '@/actions'
import Alert from '@/components/Alert'
import tmsApi from '@/api/tmsApi'
import userMixin from '@/mixins/user';

export default {
  name: 'Login',
  mixins: [userMixin],
  components: {
    Alert
  },
  data () {
    return {
      username: '',
      password: '',
      before: 'Login',
      after: 'Loading',
      errorText: '',
      errorShow: false,
      loadingSpinner: false,
      beforeClick: true,
      disabled: false,
    }
  },
  methods: {
    login () {
      if (this.formCheck() === false) {
        return
      }
      const payload = {
        username: this.username,
        password: this.password
      }
      this.loadingSpinner = true;
      this.beforeClick = false;
      this.disabled = true;
      tmsApi.login(payload).then(resp => {
        if (typeof resp.token === 'string') {
          return this.$store.dispatch('SAVE_LOGIN_STATE', resp)
        } else {
          this.setErrorResponse(resp.error)
          this.beforeClick = true;
          this.loadingSpinner = false;
          this.disabled = false;
          return false
        }
      });
    },
    formCheck () {
      if (this.username === '' || this.password === '') {
        this.setErrorResponse('Username and password cannot be empty')
        return false
      }
      return true
    },
    setErrorResponse (errorText) {
      this.errorText = errorText
      this.errorShow = true
    },
    closeAlert () {
      this.errorShow = false
    },
    redirect () {
      this.$router.push('/dashboard')
    }
  },
  computed: {
    isLoggedIn () {
      const debug = this.$store.state.loggedIn;
      return this.$store.state.loggedIn
    }
  },
  watch: {
    isLoggedIn (currentValue) {
      if (currentValue === true) {
        this.sendSelfMessage('reload');
        this.redirect()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Login.vue